/* istanbul ignore file */

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpBaseService } from '../../../core';
import { environment } from '../../../environments/environment';
import { App, Role } from '../../models';

@Injectable({
    providedIn: 'root'
})
export class RolesDataService extends HttpBaseService {

    private route = environment.api + 'apps/';

    constructor(
        private _httpClient: HttpClient
    ) {
        super(_httpClient);
    }

    deleteRole(app: App, role: Role): Observable<any> {
        const url = `${this.route}${app.id}/projects/${role.projectId}/roles/${role.id}`;
        return this.httpDelete(url);
    }

    createRole(app: App, role: Role): Observable<any> {
        const url = `${this.route}${app.id}/projects/${role.projectId}/roles`;
        return this.httpPost(url, role);
    }

    updateRole(app: App, role: Role): Observable<any> {
        const url = `${this.route}${app.id}/projects/${role.projectId}/roles/${role.id}`;
        return this.httpPut(url, role);
    }

    getAllRoles(app: App): Observable<any> {
        const url = `${this.route}${app.id}/roles`;
        return this.httpGet(url);
    }

}
